import useCartStore from "@/store/store";
import { toast } from "react-toastify";

export const handleAddToCart = (
  productId: number,
  variantId: number,
  productName: string,
  image: string,
  salePrice: number,
  originalPrice: number,
  unitCounting?: string,
  stockThreshold?: number
) => {
  const { addToCard, productCard, updateQuantity } = useCartStore?.getState();

  const isInCard = productCard.findIndex(
    (item) => item?.productId === productId && item?.variantId === variantId
  );

  if (isInCard === -1) {
    addToCard({
      variantId,
      productId,
      productName,
      image,
      salePrice,
      originalPrice,
      quantity: 1,
      unitCounting,
      stockThreshold,
    });
    toast.success("محصول به سبد خرید اضافه شد");
  } else {
    const existingItem = productCard?.[isInCard];
    updateQuantity(
      existingItem?.productId,
      existingItem?.variantId,
      existingItem?.quantity + 1,
      Number(existingItem?.stockThreshold)
    );
  }
};
